/* eslint-disable radix */

export function addModuloID(idModulo) {
  return {
    type: 'ADD_MODULO_ID',
    idModulo,
  };
}

export function addMenuID(idMenu) {
  return {
    type: 'ADD_MENU_MODULO_ID',
    idMenu,
  };
}

export function addPaginaID(idPagina) {
  return {
    type: 'ADD_PAGINA_MODULO_ID',
    idPagina,
  };
}
